import React from 'react';
import {useConsent} from '../../../ConsentContext';
import './GoogleMapsConsent.css';
import '../../Footer/Footer.css';

// The URL is only assigned to an iframe after the visitor explicitly opts in.
const MAP_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2436.543023109944!2d13.423201177859813!3d52.360572972019774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a843f39475f5bf%3A0x16ab8a7a7ad6a2e9!2sIbsenstra%C3%9Fe%2071%2C%2015831%20Blankenfelde-Mahlow!5e0!3m2!1sde!2sde!4v1767619073132!5m2!1sde!2sde';

export default function GoogleMapsConsent() {
    const {googleMaps, chooseGoogleMaps , setSettingsOpen} = useConsent();

    return (
        <section className="google-maps-consent" aria-label="Location map">
            {googleMaps === true ? (
                <>
                    <div className="google-maps-consent__toolbar">
                        <span>Google Maps is enabled.</span>
                        <button type="button" onClick={() => chooseGoogleMaps(false)}>
                            Disable map
                        </button>
                    </div>
                    <iframe
                        className="map google-maps-consent__iframe"
                        src={MAP_URL}
                        title="Google Maps – BioRetis location"
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </>
            ) : (
                <div className="google-maps-consent__placeholder">
                    <h2>View our location on Google Maps</h2>
                    <p>
                        This map is provided by Google. If you choose to load it,
                        your browser will connect to Google and personal data such as
                        your IP address may be transmitted. Google may also set or
                        access cookies. The map will not load without your consent.
                    </p>
                    <p>
                        For details, see our <a href="/privacy">Privacy Policy</a>.
                    </p>
                    <button type="button" onClick={() => chooseGoogleMaps(true)}>
                        Accept and load Google Maps
                    </button>
                    <p >
                        Your choice is saved. You can change it at any time using <a style={{cursor:"pointer"}}  onClick={() => setSettingsOpen(true)}>Cookie Settings</a>.
                    </p>
                </div>
            )}
        </section>
    );
}
